import { BFIExperienceActionType } from '../ExperienceConstants';
import { LoanActionType } from '@apply/constants';
import { executeLoanAction } from '../../../loans/common/LoanFunctions';
import store, { experienceActions } from '@apply/adminStore';
import { LoanType } from '@apply/constants';

export const executeBFIExperienceAction = (itemData: {
    id?: number;
    experienceId: number;
    loanId: number;
    loanTypeId: LoanType;
    location: Location;
}) => {
    const { dispatch } = store;

    const onViewExperience = (experienceId: number) => {
        dispatch(
            experienceActions.setBfiDetailModal({
                bfiDetailModal: { isOpen: true, id: experienceId },
            })
        );
    };

    const onViewLoan = (loanId: number, loanTypeId: LoanType, location: any) => {
        var model = {
            id: LoanActionType.Modify,
            loanId: loanId,
            loanTypeId: loanTypeId,
        };
        executeLoanAction(model, dispatch, location, false);
    };

    const onNotImplemented = () => {
        alert('Not Implemented yet!');
    };

    switch (itemData.id) {
        case BFIExperienceActionType.ViewExperience:
            onViewExperience(itemData.experienceId);
            break;
        case BFIExperienceActionType.ViewLoan:
            onViewLoan(itemData.loanId, itemData.loanTypeId, itemData.location);
            break;
        default:
            onNotImplemented();
            break;
    }
};
